// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarConatiner {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background: #dde7f5;
  z-index: 9999;
}
.SidebarConatiner .nametext {
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  color: #344054;
  padding: 1rem;
}
.SidebarConatiner .anchor_hyperlink {
  text-decoration: none;
}
.SidebarConatiner .SideBarbox {
  height: 41px;
  display: flex;
  align-items: center;
  padding: 0px 10px;
  gap: 10px;
  margin: 10px 15px;
  cursor: pointer;
  border-radius: 10rem;
}
.SidebarConatiner .SidebarConatiner .SideBarbox > span:active {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: white;
}
.SidebarConatiner .SideBarbox > span.active {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: white !important;
}
.SidebarConatiner .SubSidebarBox > span.active {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: white !important;
}
.SidebarConatiner .SideBarbox:hover {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
}
.SidebarConatiner .SideBarbox > a {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #344054;
  display: flex;
  gap: 1.5rem;
  align-items: center;
  text-decoration: none;
}
.SidebarConatiner .SideBarbox > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
}
.SidebarConatiner .SideBarbox > span:active {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff !important;
}
.SidebarConatiner .ProfileConatiner {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  width: 240px;
  height: 40px;
  left: 20px;
  top: 91px;
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
}
.SidebarConatiner .ProfileContainerImage {
  margin: 0rem 0.5rem;
}
.SidebarConatiner .sideimage {
  width: 26px;
  height: 24px;
}
.SidebarConatiner .ProfileConatinerAdmintext {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 44px;
  font-weight: 600;
}
.SidebarConatiner .ProfileConatinerAdmintexts {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 44px;
  font-weight: 600;
  margin: 0.5rem;
}
.SidebarConatiner .SubSidebarContainer {
  margin-left: 30px;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
}
.SidebarConatiner .SubSidebarBox {
  padding: 10px 0;
  cursor: pointer;
  color: #555;
  text-align: center;
}
.SidebarConatiner .SideBarbox.active {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: white !important;
}
.SidebarConatiner .SubSidebarBox.active {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: white !important;
  text-align: center;
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .SideBarbox > span {
    font-size: 11px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Sidebar/sidebar.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AACF;AACE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;AACJ;AAEE;EACE,qBAAA;AAAJ;AAGE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;AADJ;AAIE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAFJ;AAKE;EACE,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AAHJ;AAME;EACE,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AAJJ;AAOE;EACE,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AALJ;AASE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;AAPJ;AAUE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AARJ;AAYE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAVJ;AAcE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,mEAAA;EACA,8CAAA;EACA,kBAAA;AAZJ;AAeE;EACE,mBAAA;AAbJ;AAgBE;EACE,WAAA;EACA,YAAA;AAdJ;AAiBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAfJ;AAkBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAhBJ;AAmBE;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAjBJ;AAoBE;EACE,eAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AAnBJ;AAsBE;EACE,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;AApBJ;;AAwBA;EACE;IACE,0BAAA;EArBF;AACF","sourcesContent":[".SidebarConatiner {\n  width: 100%;\n  height: 100%;\n  overflow-y: scroll;\n  background: #dde7f5;\n  z-index: 9999;\n\n  .nametext {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 28px;\n    color: #344054;\n    padding: 1rem;\n  }\n\n  .anchor_hyperlink {\n    text-decoration: none;\n  }\n\n  .SideBarbox {\n    height: 41px;\n    display: flex;\n    align-items: center;\n    padding: 0px 10px;\n    gap: 10px;\n    margin: 10px 15px;\n    cursor: pointer;\n    border-radius: 10rem;\n  }\n\n  .SidebarConatiner .SideBarbox>span:active {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 15px;\n    color: white;\n  }\n\n  .SideBarbox>span.active {\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 15px;\n    color: white !important;\n  }\n\n  .SubSidebarBox > span.active {\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 15px;\n    color: white !important;\n  }\n\n  .SideBarbox:hover {\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 15px;\n    color: #ffffff;\n\n  }\n\n  .SideBarbox>a {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    color: #344054;\n    display: flex;\n    gap: 1.5rem;\n    align-items: center;\n    text-decoration: none;\n  }\n\n  .SideBarbox>span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 15px;\n\n  }\n\n  .SideBarbox>span:active {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 15px;\n    color: #ffffff !important;\n\n  }\n\n  .ProfileConatiner {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: center;\n    width: 240px;\n    height: 40px;\n    left: 20px;\n    top: 91px;\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px;\n  }\n\n  .ProfileContainerImage {\n    margin: 0rem 0.5rem;\n  }\n\n  .sideimage {\n    width: 26px;\n    height: 24px;\n  }\n\n  .ProfileConatinerAdmintext {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 44px;\n    font-weight: 600;\n  }\n\n  .ProfileConatinerAdmintexts {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 44px;\n    font-weight: 600;\n    margin: 0.5rem;\n  }\n\n  .SubSidebarContainer {\n    margin-left: 30px;\n    margin-top: 15px;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .SubSidebarBox {\n    padding: 10px 0;\n    cursor: pointer;\n    color: #555;\n    text-align: center;\n  }\n\n  .SideBarbox.active {\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 15px;\n    color: white !important;\n  }\n\n  .SubSidebarBox.active {\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 15px;\n    color: white !important;\n    text-align: center;\n  }\n}\n\n@media screen and (min-width:768px) and (max-width:1024px) {\n  .SideBarbox>span {\n    font-size: 11px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
